import { Component, Input } from "@angular/core";
import { DeviceAdvFilterInfo, DeviceAdvFilterOptionInfo, DeviceAdvFilterType } from "./dev-adv-filter.data";

@Component({
    selector: 'na-dev-adv-filter-item',
    templateUrl: './dev-adv-filter-item.component.html',
    styleUrls: ['./dev-adv-filter-item.component.css']
})
export class DeviceAdvanceFilterItemComponent {
    readonly FILTER_TYPE_GROUP: DeviceAdvFilterType = 'group';
    readonly FILTER_TYPE_SELECT: DeviceAdvFilterType = 'select';
    readonly FILTER_TYPE_SIMPLE_SELECT: DeviceAdvFilterType = 'simple-select';
    readonly FILTER_TYPE_MULTI_SELECT: DeviceAdvFilterType = 'multi-select'
    readonly FILTER_TYPE_TEXT: DeviceAdvFilterType = 'text-with-options';

    @Input('source') _source: DeviceAdvFilterInfo;
    @Input('loading') _loading: boolean = false;

    selectFilter(filter: DeviceAdvFilterInfo): void {
        if (filter.type == this.FILTER_TYPE_SIMPLE_SELECT) {
            if (!filter.dropdownShow) {
                // should set show to false for all the other simple-select filters
            }
        }

        filter.dropdownShow = !filter.dropdownShow;
    }

    chooseSingleSelectFilterOption(filter: DeviceAdvFilterInfo, option: DeviceAdvFilterOptionInfo): void {
        filter.dropdownShow = !filter.dropdownShow
        filter.optionList.forEach(option => option.isDefault = false);
        option.isDefault = true;
        filter.option = option;
    }

    chooseMultiSelectFilter(filter: DeviceAdvFilterInfo, checked: boolean): void {
        filter.isDefault = checked;
        filter.optionList?.forEach(option => option.isDefault = checked);
    }

    chooseMultiSelectFilterOption(filter: DeviceAdvFilterInfo, option: DeviceAdvFilterOptionInfo, checked: boolean): void {
        option.isDefault = checked;
        if (option.isDefault) {
            filter.isDefault = true;
        }
        else {
            let isOptionSelected: boolean = false;
            for (let option of filter.optionList) {
                if (option.isDefault) {
                    isOptionSelected = true;
                    break;
                }
            }

            if (!isOptionSelected) {
                filter.isDefault = false;
            }
        }
    }
}